import { GlButton, GlButtonGroup, GlTooltipDirective } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { jumpToQuestion } from 'ee/work_items/utils/question_navigation';
import { QUESTION_NAVIGATION_NEXT, QUESTION_NAVIGATION_PREVIOUS } from 'ee/work_items/constants';
import { InternalEvents } from '../../../../../../../app/assets/javascripts/tracking/index.js?vue3';
import { WORKPLAN_QUESTION_NAVIGATION_EVENT, WORKPLAN_QUESTION_NAVIGATION_SURFACES } from './constants';
export default {
    name: 'WorkplanQuestionNavigator',
    components: {
        GlButton,
        GlButtonGroup
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        InternalEvents.mixin()
    ],
    props: {
        questions: {
            type: Array,
            required: true
        },
        surface: {
            type: String,
            required: true,
            validator: (value)=>Object.values(WORKPLAN_QUESTION_NAVIGATION_SURFACES).includes(value)
        }
    },
    computed: {
        openNoteIds () {
            return this.questions.filter(({ answered })=>!answered).map(({ noteId })=>noteId);
        }
    },
    methods: {
        jump (direction) {
            jumpToQuestion({
                noteIds: this.openNoteIds,
                direction
            });
            this.trackEvent(WORKPLAN_QUESTION_NAVIGATION_EVENT, {
                label: direction,
                property: this.surface
            });
        }
    },
    QUESTION_NAVIGATION_NEXT,
    QUESTION_NAVIGATION_PREVIOUS
};
